"use client";
import HamburgerComponent from "../Hamburger/HamburgerComponent";
import React, { useEffect, useRef, useState } from "react";
import styles from "./Header.module.css";

import CustomImageComponent from "../Image/Image";
import useIsMobile from "../../../customHooks/IsMobile";
import { multipleClassName } from "../../../utils/helpers";
import CustomLinkComponent from "../Link/Link";
import { useDownloadContext } from "../../../contexts/CommonContext";
import { IHeaderComponentProps } from "../../../types/components";
import Button from "../Button/PrimaryButton";
import Image from "next/image";
import Dropdown from "./dropdown/Dropdown";
import { PAGE_TYPE } from "../../../utils/enums";

const HeaderComponentV2 = (props: IHeaderComponentProps) => {
  
  const { isMobileDevice } = useIsMobile();
  const { menuOpen } = useDownloadContext();
  const [isDropDownOpen, setIsDropDownOpen] = useState<any>({});
  const [hover, setHover] = useState<number | null>(null);

  useEffect(() => {
    const handler = (event: any) => {
      console.log(event.target.id);

      if (event.target.id.includes("dropDown")) {
        setIsDropDownOpen((prev : any) => {
          return { [event.target.id]: !prev[event.target.id] };
        });
      } else {
        setIsDropDownOpen({});
      }
    };
    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("click", handler);
    };
  }, []);

  const {
    specialData,
    fixedDownloadButtonData,
    languageToggleData,
    locale,
    mainLogo,
    mainLogoAlt,
  } = props.HeaderDataJson;

  const { pageType } = props;

  let showLanguageToggle = true;
  const hideHamburger: boolean = props.hideHamburger || false;

  const toggleLanguageProps = {
    languageToggleData: languageToggleData,
    locale: locale,
  };

  const dropDownActions = [
    () => window.open("https://console.winzogames.com/", "_blank"),
    () => window.open("https://zo.games/", "_blank"),
  ];

  return fixedDownloadButtonData ? (
    <>
      <header
        className={styles.header}
        style={{
          display: "flex",
        }}
      >
        <div className={"container"}>
          <nav className={multipleClassName("nav", styles.nav)}>
            <div className={styles.logoContainer}>
              <div className={styles.logoImg} style={pageType === PAGE_TYPE.GCOE ? {height: 40} : {}}>
                <CustomLinkComponent href={"/"}>
                  <CustomImageComponent
                    layout={"fill"}
                    objectFit={"contain"}
                    src={mainLogo}
                    alt={mainLogoAlt || "WinZO Games Logo"}
                    priority={true}
                    sizes="(max-width: 576px) 42vw, (max-width: 1200px) 21vw, 20vw"
                  />
                </CustomLinkComponent>
              </div>
              {/* <div className={styles.languageToggle}>
                                {showLanguageToggle && languageToggleData && (
                                    <LanguageToggleComponent
                                        {...toggleLanguageProps}
                                    />
                                )}
                            </div> */}
            </div>

            <div className={styles.navItemsContainer}>
              <div
                className={styles.navItems}
                style={
                  (typeof isMobileDevice === "undefined" || isMobileDevice) && pageType !== PAGE_TYPE.GCOE
                    ? {
                        display: `${"none"}`,
                      }
                    : {}
                }
              >
                <ul>
                  {!menuOpen &&
                    specialData &&
                    specialData.map((item: any, index: number) => {
                      if (item.dropdown) {
                        return (
                          <div key={index} style={{ position: "relative", height: "100%" }}>
                            <div
                              key={index}
                              id={`dropDown${index}`}
                              className={multipleClassName(
                                styles.dropDownContainer,
                                isDropDownOpen[`dropDown${index}`] &&
                                  styles.dropDownContainerActive
                              )}
                              onMouseEnter={() => setHover(index)}
                              onMouseLeave={() => setHover(null)}
                            >
                              <div
                                className={styles.dropDownButton}
                                id={`dropDown${index}`}
                              >
                                {item.title}
                              </div>
                              <div
                                id={`dropDown${index}`}
                                className={styles.dropDownArrow}
                                style={
                                  !isDropDownOpen[`dropDown${index}`]
                                    ? {
                                        transition: "all 0.2s ease-in",
                                        transform: "rotate(180deg)",
                                      }
                                    : {
                                        transition: "all 0.2s ease-in",
                                        transform: "rotate(0deg)",
                                      }
                                }
                              >
                                <Image
                                  id={`dropDown${index}`}
                                  src={
                                    hover === index ||
                                    isDropDownOpen[`dropDown${index}`]
                                      ? "https://d3g4wmezrjkwkg.cloudfront.net/zo-business/staging/Images/dropDownArrowBlack.webp"
                                      : "https://d3g4wmezrjkwkg.cloudfront.net/zo-business/staging/Images/dropdownArrow.webp"
                                  }
                                  alt="Dropdown Arrow"
                                  fill
                                  objectFit="contain"
                                />
                              </div>
                            </div>
                            <div
                              className={styles.dropDownContent}
                              style={
                                !isDropDownOpen[`dropDown${index}`]
                                  ? {
                                      transition: "all 0.2s ease-in",
                                      pointerEvents: "none",
                                      opacity: 0,
                                      maxHeight: 0,
                                    }
                                  : {
                                      transition: "all 0.2s ease-in",
                                      pointerEvents: "all",
                                      opacity: 1,
                                      maxHeight: "200px",
                                    }
                              }
                            >
                              <Dropdown
                                dropDownData={item.dropdown}
                                dropDownActions={dropDownActions as Function[]}
                              />
                            </div>
                          </div>
                        );
                      }
                      if (item.special && !item.dropdown) {
                        if (item.isButtonType) {
                          return (
                            <a href={item.link}>
                              <Button
                                text={item.title}
                                bgColor="rgba(0, 0, 0, 0.3)"
                                bgImage="none"
                                gradientBorder="none"
                                border={pageType === PAGE_TYPE.GCOE ? "2px solid white" : "1px solid white"}
                                style={{
                                  fontWeight: 600,
                                  fontStyle: "italic",
                                  fontSize: "clamp(9px,0.9,18px)",
                                }}
                                pageType={pageType}
                              />
                            </a>
                          );
                        }
                        return (
                          <li key={index} className={styles.greenBackground}>
                            {item.outside ? (
                              <a
                                href={item.link}
                                target="_blank"
                                rel={"noreferrer"}
                              >
                                <span>{item.title}</span>
                              </a>
                            ) : (
                              <CustomLinkComponent
                                href={item.link}
                                mobStyle={{
                                  textDecoration: "none",
                                }}
                                desktopStyle={{
                                  textDecoration: "none",
                                }}
                              >
                                <span>{item.title}</span>
                              </CustomLinkComponent>
                            )}
                          </li>
                        );
                      }
                      return <></>;
                    })}
                </ul>
              </div>
              {/* {hideDownloadButton ? (
                                <></>
                            ) : (
                                <FixedDownloadButtonV2
                                    {...fixedDownloadBtnProps}
                                />
                            )}
                            {headerType === GDC_HEADER_TYPE &&
                                props.seasonToggleData &&
                                !isMobileDevice && (
                                    <HeaderVersionToggle
                                        {...props.seasonToggleData!}
                                    />
                                )}
                            {headerType === GDC_HEADER_TYPE &&
                            showSubmitButton ? (
                                <GDCSubmitButton
                                    text={gdcButtonText}
                                    url={gdcFormUrl}
                                    type={HEADER_DOWNLOAD_BUTTON_TYPE}
                                    sendAnalytics={sendAnalyticsGDCHedaer}
                                />
                            ) : (
                                <></>
                            )} */}
              {!hideHamburger && isMobileDevice && <HamburgerComponent />}
            </div>
          </nav>
        </div>
      </header>
    </>
  ) : (
    <></>
  );
};

export default HeaderComponentV2;
